
import { Faqs } from "../models/faqs.model";
import { allApis } from "./allApis";

export const faqsApi = allApis.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getfaqs: builder.query<Faqs[], void>({
      query: () => 'faqs',
    }),
    getRelatedFaqs: builder.query<Faqs[], string>({
      query: (id) => ({
        url: `faqs/relatedFaqs/${id}`,
      }),
    }),
    updatefaqs: builder.mutation<Faqs, { id: string; type: 'yes' | 'no' }>({
      query: ({ id, type }) => ({
        url: `faqs/update-count/${id}`,  
        method: 'PUT',
        body: { type }, 
      }),
    }),

    
    
  }),
});
export const {useGetfaqsQuery, useGetRelatedFaqsQuery, useUpdatefaqsMutation} = faqsApi;

